export interface SongLibraryStatus {
  countLabel: string;
  title: string;
  body: string;
  emptyLibrary: boolean;
}

export function songLibraryStatus(input: {
  libraryTotal: number | null;
  matchTotal: number;
  filtersActive: boolean;
}): SongLibraryStatus {
  const emptyLibrary = input.libraryTotal === 0
    || (input.libraryTotal === null && !input.filtersActive && input.matchTotal === 0);
  if (emptyLibrary) {
    return {
      emptyLibrary: true,
      countLabel: "0 songs",
      title: "No songs yet",
      body: "New songs stay in this library after you save them.",
    };
  }
  if (input.filtersActive && input.matchTotal === 0) {
    return {
      emptyLibrary: false,
      countLabel: "0 matching songs",
      title: "No songs in this filter",
      body: "Clear the title, key, tag, or favourites to see the songs in this library.",
    };
  }
  const countLabel = `${input.matchTotal} song${input.matchTotal === 1 ? "" : "s"}`;
  return { emptyLibrary: false, countLabel, title: "", body: "" };
}
